import * as React from 'react';

import { ColorSelect as CoreColorSelect } from '../../colorselect/ColorSelect';
import { FormItem } from './FormItem';
import { Field } from '../Field';

import type { FieldRenderProps } from 'react-final-form';

import type { VFFieldProps } from '../types';
import { DATA_FORM_INPUT } from '../../common/data';

export type ColorSelectProps = VFFieldProps<
  React.ComponentProps<typeof CoreColorSelect>
>;
export const ColorSelect = React.forwardRef<HTMLInputElement, ColorSelectProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      onChange: customOnChange,
      onBlur: customOnBlur,
      required,
      disabled,
      readOnly,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (value: any) => {
                const rv = { target: { name, value } };
                customOnChange ? customOnChange(rv) : onChange?.(rv);
              },
              [customOnChange, onChange, name]
            );
            const handleBlur = React.useCallback(
              (value: any) => {
                onBlur({
                  target: { name, value },
                } as any as React.FocusEvent<HTMLElement>);
                customOnBlur && customOnBlur({ target: { name, value } });
              },
              [customOnBlur, onBlur, name]
            );
            return (
              <CoreColorSelect
                {...DATA_FORM_INPUT(name)}
                className={className}
                // @ts-ignore
                ref={ref}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                onChange={handleChange}
                onBlur={handleBlur}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
